[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 2,
                "key": "JAwRPqUH8FpRph3cEVbrT"
            },
            {
                "x": 19,
                "y": 2,
                "key": "AOBn7MpwmOPobQVpSPj8r"
            },
            {
                "x": 19,
                "y": 10,
                "key": "bqb2eGnG9X_EgIljcVw3m"
            },
            {
                "x": 12,
                "y": 10,
                "key": "0H4pVmM_e3jhjTK2aw4us"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 11,
                "y": 11,
                "key": "-JbJPnwFpW-ICGGZ_MzpU"
            },
            {
                "x": 20,
                "y": 11,
                "key": "Lup6irnqNdPhQW034bG95"
            },
            {
                "x": 20,
                "y": 16,
                "key": "mjCIS78KcOnSNmMsRyKsn"
            },
            {
                "x": 11,
                "y": 16,
                "key": "pe7bEKwUfGn5Pq9IjawaX"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 17,
                "key": "_Ue9GVClDC5sSouM100mX"
            },
            {
                "x": 19,
                "y": 17,
                "key": "no-LH7rJONLmxBpwyx8vD"
            },
            {
                "x": 19,
                "y": 24,
                "key": "CGTGHajLsvcDYMG1SSM0P"
            },
            {
                "x": 12,
                "y": 24,
                "key": "00T2MFBIwAAgJzD8ymbXA"
            }
        ]
    }
]